<div class="infinity-logo-wrapper">
	<img class="infinity-logo" src="assets/images/homescreen/infinity_logo.svg" alt="Infinity Logo">
</div>
<div class="text-center tig-middle-box animated fadeInDown">
	<div>
		<div class="wcms-logo-wrapper">
			<img class="wcms-logo" src="assets/images/homescreen/infinity_wcms_logo_signet.svg" alt="WCMS Logo">
		</div>
		<p class="text-white wcms-text-shadow">{{"oClientSelection.sNeedMoreRights"|translate}}<br>
			<a class="text-white text-underline" href="https://vogelmedia.jira.com/servicedesk/customer/portal/6/group/169/create/88">{{"oClientSelection.sRequestRights"|translate}}</a></p>
		<div class="wrapper">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
					<h5>{{"clients"|translate}}</h5>
				</div>
				<div class="ibox-content">
					<div class="table-responsive">
						<table datatable [dtOptions]="OBJ_dt_options" class="table table-striped table-bordered hover"></table>
					</div>
				</div>
			</div>
		</div>
		<p class="m-t"><small [innerHTML]="STR_company"></small></p>
	</div>
</div>
